import AppReadOnlyView from './AppReadOnlyView'
import * as React from 'react'
import {IFeatureLayerInfo} from '../../core/interfaces/models'
import appConfig from '../../reducers/appConfig'
import {Feature} from '../../core/models'
import {StreetAreaView} from './StreetReg/StreetAreaView'
import {IUser} from '../../core/interfaces/reducers'
import {IMapDispatcher} from '../../core/interfaces/dispatchers'

interface Props {
  feature: Feature
  layerInfo: IFeatureLayerInfo
  style?: React.CSSProperties
  user?: IUser
  mapDispatcher?: IMapDispatcher
}

interface State {}
export class ReadOnlyDispatcher extends React.Component<Props, State> {
  render() {
    if (this.props.layerInfo.url == appConfig.streetreg.area.url) {
      return (
        <StreetAreaView
          mapDispatcher={this.props.mapDispatcher}
          layerInfo={this.props.layerInfo}
          feature={this.props.feature}
        />
      )
    }
    return (
      <AppReadOnlyView
        mapDispatcher={this.props.mapDispatcher}
        layerInfo={this.props.layerInfo}
        feature={this.props.feature}
      />
    )
  }
}
